import React from "react";
import classnames from "classnames";

interface Props {
  children: React.ReactNode;
  className?: string;
  id: string;
  style?: React.CSSProperties;
  highlight?: boolean;
}

export const RoundedCard = ({
  children,
  className,
  id,
  style,
  highlight,
}: Props) => {
  const cardClass = classnames(
    "rounded-card",
    "p-4",
    highlight && "highlight-card",
    className
  );

  return (
    <div id={id} className={cardClass} style={style}>
      {children}
    </div>
  );
};
